import {Stack} from "@mui/material";
import ExportPdf from "@containers/export/containers/pdf/ExportPdf";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {
    GenerateExportExcelHeadColumnStylesCb,
    GenerateExportExcelRowStylesCb,
    HeadColumns,
    IBaseExportStyles
} from "@ui/tableCustom/types/table";
import {IQueryParamsContext} from "@hooks/query/types/queryParams";
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {ExportPdfContent} from "@containers/export/containers/pdf/types";
import ExportExcel from "@containers/export/containers/excel/ExportExcel";

interface IProps<T> {
    exportMutate: IExportMutateContext<T>,
    exportParams: IExportParamsContext<T>,
    fullColumns: IColumnItem<T>[],
    headColumns?: HeadColumns<T>,
    params: IQueryParamsContext<T>,
    baseExportStyles?: IBaseExportStyles<T>,
    allData?: T[],
    headerExportContents?: {
        pdf?: ExportPdfContent,
        excel?: any
    },
    generateExportExcelRowStylesCb?: GenerateExportExcelRowStylesCb<T>
    generateExportExcelHeadColumnStylesCb?: GenerateExportExcelHeadColumnStylesCb,
    hasPdfExport?: boolean,
    disabled?: boolean,
    hasExport?: boolean,
    onDownload?: () => void,

}

function DownloadExport<T>({
                               exportMutate,
                               exportParams,
                               fullColumns,
                               headColumns,
                               baseExportStyles,
                               allData,
                               params,
                               headerExportContents,
                               onDownload,
                               hasPdfExport,
                               generateExportExcelRowStylesCb,
                               generateExportExcelHeadColumnStylesCb,
                           }: IProps<T>) {
    const {
        fileName,
        settings,
        additionalDataSet,
        exportDataFromAllPage,
    } = exportParams;

    const {
        ignoredExportColumnKey,
        rootDataSetPosition,
        rootYSteps,
        exportFromAllColumns,
    } = settings;

    const {
        columnExport,
        dataExp,
    } = exportMutate;

    const {
        order,
        direction,
    } = params;

    return (
        <Stack
            direction={'row'}
            gap={'13px'}
        >

            {hasPdfExport && <ExportPdf
                <T>
                fileName={fileName}
                baseSettings={baseExportStyles?.pdf?.settings}
                baseSettingsCb={baseExportStyles?.pdf?.callback}
                headerContents={headerExportContents?.pdf}
                onDownload={onDownload}
                data={dataExp}
                fullColumns={fullColumns}
                headColumns={headColumns}
                columnExport={columnExport}
                ignoredExportColumnKey={ignoredExportColumnKey}
                additionalDataSet={additionalDataSet}
                allData={allData}
                exportDataFromAllPage={exportDataFromAllPage}
                order={order}
                direction={direction}
                exportFromAllColumns={exportFromAllColumns}
            />}

            <ExportExcel
                <T>
                fileName={fileName}
                onDownload={onDownload}
                generateExportExcelRowStylesCb={generateExportExcelRowStylesCb}
                generateExportExcelHeadColumnStylesCb={generateExportExcelHeadColumnStylesCb}
                data={dataExp}
                fullColumns={fullColumns}
                headColumns={headColumns}
                columnExport={columnExport}
                ignoredExportColumnKey={ignoredExportColumnKey}
                additionalDataSet={additionalDataSet}
                allData={allData}
                exportDataFromAllPage={exportDataFromAllPage}
                order={order}
                direction={direction}
                rootDataSetPosition={rootDataSetPosition}
                rootYSteps={rootYSteps}
                exportFromAllColumns={exportFromAllColumns}
                baseSettings={baseExportStyles?.excel?.settings}
            />
        </Stack>
    )
};

export default DownloadExport